import React from 'react';
import classNames from 'classnames';
import proptypes from 'prop-types';
import { Checkbox, Typography } from '@one-thd/sui-atomic-components';
import { DragHandle } from '@thd-olt-component-react/drag-and-drop/dist/drag-and-drop';

const { bool, number, func, string } = proptypes;

const DragHandleContainer = ({
  id, itemRef, onCheck, checked, numbering, disableSelection,
  disableDragAndDrop, showHorizontalDragHandleContainer, renderDeleteButton
}) => {
  const rootClasses = classNames('sui-relative sui-h-auto sui-flex-col sui-flex');

  const checkboxContainerClasses = classNames('sui-self-start sui-flex-1 [&>*]:sui-pt-0', {
    'sui-mb-2': !showHorizontalDragHandleContainer
  });

  const dragContainerClass = classNames('sui-flex', { 'sui-pr-4': (!disableSelection || !disableDragAndDrop) });

  if (showHorizontalDragHandleContainer) {
    return (
      <div className="sui-flex sui-justify-between sui-px-3">
        <div className="sui-gap-3 sui-flex">
          {!disableDragAndDrop && (
            <div className="sui-pt-1">
              <DragHandle id={id} sortableRef={itemRef} />
            </div>
          )}
          <div className="sui-flex sui-pt-1">
            <Typography color="primary" component="span" variant="body-lg">
              {numbering}
            </Typography>
            <div className={rootClasses}>
              {!disableSelection && (
                <div className={checkboxContainerClasses}>
                  <Checkbox
                    id={`productlist-${id}`}
                    onChange={onCheck}
                    checked={checked}
                    data-id="list-item-check-box"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {renderDeleteButton && renderDeleteButton(id)}
      </div>
    );
  }

  return (
    <div className={dragContainerClass}>
      <Typography color="primary" component="span" variant="body-lg">
        {numbering}
      </Typography>
      <div className={rootClasses}>
        {!disableSelection && (
          <div className={checkboxContainerClasses}>
            <Checkbox
              id={`productlist-${id}`}
              onChange={onCheck}
              checked={checked}
              data-id="list-item-check-box"
            />
          </div>
        )}

        {!disableDragAndDrop && (
          <div className="sui-self-center sui-flex sui-flex-1 sui-items-center">
            <div className="sui-h-6 sui-w-6">
              <DragHandle id={id} sortableRef={itemRef} />
            </div>
          </div>
        )}
        {/* Spacer. Makes handle vertically center, might be a better solution such as grid */}
        <div className="sui-flex-1" />
      </div>
    </div>
  );
};

DragHandleContainer.propTypes = {
  id: string.isRequired,
  itemRef: func,
  onCheck: func,
  checked: bool,
  numbering: number,
  disableSelection: bool,
  disableDragAndDrop: bool,
  showHorizontalDragHandleContainer: bool,
  renderDeleteButton: func
};

DragHandleContainer.defaultProps = {
  onCheck: null,
  checked: false,
  numbering: null,
  itemRef: null,
  disableSelection: false,
  disableDragAndDrop: false,
  showHorizontalDragHandleContainer: false,
  renderDeleteButton: () => {}
};

DragHandleContainer.displayName = 'DragHandleContainer';

export { DragHandleContainer };
